export {
    getAndShowThemeG,
    setHeadTitleG
}

//REFACTORED FUNCTION, NOT CLEAN
//Описание: метод достает данные из loacalStorage и в зависимости от данных применяет нужную тему страницы,
//путем изменения href тега link в head'e документа.   
function getAndShowThemeG(){
  let theme_value = localStorage.getItem('theme') || 'black';
  let themes = {
    'white': 'themes/white.css',
    'not pink': 'themes/not_pink.css',
    'pearl': 'themes/pearl.css',
    'black': '#'
  }
  for (let theme in themes){
    if(theme === theme_value){
      let theme_path = themes[theme];
      document.querySelector('link.page_theme').href = './' + theme_path;
    }
  }
}


function setHeadTitleG(title) {
  document.querySelector('head title').textContent = title;
}